// *****************************************************
// OBJECTS
// *****************************************************

export const THUNK_ACTION_RESULT_TYPE = {
	SUCCESS: "SUCCESS",
	ERROR: "ERROR",
} as const;

export const API_RETURN_TYPE = {
	ERROR_KNOWN: "ERROR_KNOWN",
	ERROR_UNKNOWN: "ERROR_UNKNOWN",
	SUCCESS: "SUCCESS",
	SUCCESS_NO_CONTENT: "SUCCESS_NO_CONTENT",
} as const;

export const DEVIATION_MODAL_TYPE = {
	None: "Deviation-None",
	Edit: "Deviation-Edit",
	Resolve: "Deviation-Resolve",
	Delete: "Deviation-Delete",
};

export const HISTORICAL_DATA_AGGREGATION = {
	All: "0",
	Site: "1",
	Unit: "2",
	Device: "3",
} as const;

export const KNOWLEDGER_API_SOURCE = {
	CONTROL_SYSTEM: "CONTROL_SYSTEM",
	FEED_STATION: "FEED_STATION",
	CORE: "CORE",
	VISION: "VISION",
	CAMERA: "CAMERA",
	MERCATUS: "MERCATUS",
} as const;

export const KNOWLEDGER_API_RELATION_TYPE = {
	Activity: "Activity",
	Camera: "Camera",
	Deviation: "Deviation",
	FeedingComponent: "FeedingComponent",
	Generic: "Generic",
	Silo: "Silo",
	Site: "Site",
	Software: "Software",
	Unit: "Unit",
	Feeding: "Feeding",
	DailyReport: "DailyReport",
	Device: "Device",
	FeedLoss: "FeedLoss",

	//FeedStation specific
	FeedingLine: "FeedingLine",
	Pipe: "Pipe",
	Blower: "Blower",
	Auger: "Auger",
	Sluice: "Sluice",
	Selector: "Selector",
	Version: "Version",
	PLC: "PLC",
	PlcVersion: "PlcVersion",

	// Core specific
	OpcUaDevice: "OpcUaDevice",
	HybridPowerSystem: "HybridPowerSystem",
	BcTankSounding: "BcTankSounding",
	BilgePump: "BilgePump",
	Generator: "Generator",
	GenericIO: "GenericIO",
	BallastSystem: "BallastSystem",
	Hatch: "Hatch",
	Orbit: "Orbit",
	KNX: "KNX",
	Inclinometer: "Inclinometer",
	Thermolicer: "Thermolicer",
	Thermolicer1: "Thermolicer1",
	Thermolicer2: "Thermolicer2",
	StationLogger: "StationLogger",
	CameraDevice: "CameraDevice",
	VideoStreaming: "VideoStreaming",
	GenericModbusDevice: "GenericModbusDevice",
	GMTFeeder: "GMTFeeder",
	TrimTank: "TrimTank",
	STVHatch: "STVHatch",
	OxygenGenerator: "OxygenGenerator",
	SiloMeasurement: "SiloMeasurement",
	LoraBaseDevice: "LoraBaseDevice",
	FluctusDevice: "FluctusDevice",
} as const;

export const CAUSALITY = {
	CAUSED_BY: "CAUSED_BY",
	IS_CAUSING: "IS_CAUSING",
	IMPACTS: "IMPACTS",
	RELATES_TO: "RELATES_TO",
	BLOCKS: "BLOCKS",
	BELONGS_TO: "BELONGS_TO",
	PART_OF: "PART_OF",
} as const;

export const DOC_TYPE = {
	Activity: "Activity",
	Comment: "Comment",
	DailyReport: "DailyReport",
	Deviation: "Deviation",
	FeedLoss: "FeedLoss",
	FeedPlan: "FeedPlan",
	Meal: "Meal",
	UserSettings: "UserSettings",
} as const;

export const FEED_PLAN_SOURCE = {
	ManualPlan: "ManualPlan",
	FeedStation: "FeedStation",
	Farmer: "Farmer",
} as const;

export const ACTIVITY_MODAL_TYPE = {
	None: "Activity-None",
	Edit: "Activity-Edit",
	Duplicate: "Activity-Duplicate",
	Complete: "Activity-Complete",
	Start: "Activity-Start",
	Cancel: "Activity-Cancel",
	Delete: "Activity-Delete",
} as const;

export const NUMERICAL_LOCALE = {
	English: "en-gb",
	Norwegian: "no",
} as const;

export const NEXT_LOCALE = {
	English: "en",
	Norwegian: "nb",
} as const;

export const REQUEST_METHOD = {
	GET: "GET",
	HEAD: "HEAD",
	POST: "POST",
	PUT: "PUT",
	DELETE: "DELETE",
	CONNECT: "CONNECT",
	OPTIONS: "OPTIONS",
	TRACE: "TRACE",
	PATCH: "PATCH",
} as const;

export const HTTP_HEADER = {
	ApplicationId: "X-Application-Id",
	Authorization: "Authorization",
	ContentType: "Content-Type",
} as const;

export const KEY_CODE = {
	Enter: "Enter",
} as const;

export const HTTP_CONTENT_TYPE = {
	JSON: "application/json",
} as const;

export const HTML_TAG_NAME = {
	Input: "INPUT",
} as const;

export const REDUCER_PATH = {
	Menu: "menu",
	Filter: "filter",
	Realtime: "realtime",
	RealtimeFilter: "realtimeFilter",
	Activity: "activity",
	Deviation: "deviation",
	Log: "log",
	Dashboard: "dashboard",
	Settings: "settings",
	Snackbar: "snackbar",
	Auth: "auth",
} as const;

export const QUICK_ACTION_MENU_SOURCE_TYPE = {
	Report: "log",
	Dashboard: "dashboard",
	Table: "table",
	View: "view",
} as const;

export const SCALE_ROLE = {
	Admin: "scaleaq/administrator",
	SupportAgent: "scaleaq/support_agent",
	AccountManager: "scaleaq/account_manager",
} as const;

export const UNLEASH_FLAG = {
	Insights: "knowledger.insights",
} as const;

export const BUCKET_SIZE = {
	ONE_SECOND: "0.00:00:01",
	TEN_SECOND: "0.00:00:10",
	THIRTY_SECOND: "0.00:00:30",
	ONE_MINUTE: "0.00:01:00",
	THREE_MINUTE: "0.00:03:00",
	FIVE_MINUTE: "0.00:05:00",
	TEN_MINUTE: "0.00:10:00",
	ONE_HOUR: "0.01:00:00",
	TWO_HOURS: "0.02:00:00",
	SIX_HOUR: "0.06:00:00",
	TWELEVE_HOUR: "0.12:00:00",
	ONE_DAY: "1.00:00:00",
} as const;

export const ACTIVITY_STATUS = {
	PLANNED: "PLANNED",
	STARTED: "STARTED",
	COMPLETED: "COMPLETED",
	CANCELED: "CANCELED",
} as const;

export const DEVIATION_SEVERITY = {
	MINIMAL: "MINIMAL",
	MODERATE: "MODERATE",
	CRITICAL: "CRITICAL",
} as const;

export const REALTIME_CUSTOM_FILTER_TYPE = {
	AllUnits: "allUnits",
	UnitsWithData: "unitsWithData",
	UnitsWithOngoingFeeding: "unitsWithOngoingFeeding",
} as const;

export const SITE_AVERAGE_TYPE = {
	Last24Hours: "last24Hours",
	Last12Hours: "last12Hours",
	Last6Hours: "last6Hours",
	Last3Hours: "last3Hours",
	Day: "1.00:00:00",
	TwelveHours: "12:00:00",
	SixHours: "06:00:00",
	ThreeHours: "03:00:00",
	None: "00:00:00",
} as const;

export const CREATION_MODAL_TYPE = {
	ACTIVITY: "ACTIVITY",
	DEVIATION: "DEVIATION",
	LOG: "LOG",
} as const;

export const ERROR_TYPE = {
	API: "API",
	API_NO_CONTENT: "API_NO_CONTENT",
	API_VALIDATION: "API_VALIDATION",
	MISSING_SILOS: "MISSING_SILOS",
	NO_SELECTED_SITE: "NO_SELECTED_SITE",
	HOOK_VALIDATION: "HOOK_VALIDATION",
	NO_USER_IN_GOS: "NO_USER_IN_GOS",
	NO_ACCESS_FROM_GOS: "NO_ACCESS_FROM_GOS",
	MISSING_SITE: "MISSING_SITE",
	MISSING_UNITS: "MISSING_UNITS",
} as const;

// *****************************************************
// ARRAYS
// *****************************************************

export const HISTORICAL_DATA_AGGREGATIONS = Object.values(HISTORICAL_DATA_AGGREGATION);
export const KNOWLEDGER_API_SOURCES = Object.values(KNOWLEDGER_API_SOURCE);
export const KNOWLEDGER_API_RELATION_TYPES = Object.values(KNOWLEDGER_API_RELATION_TYPE);
export const CAUSALITIES = Object.values(CAUSALITY);
export const DOC_TYPES = Object.values(DOC_TYPE);
export const FEED_PLAN_SOURCES = Object.values(FEED_PLAN_SOURCE);
export const ACTIVITY_MODAL_TYPES = Object.values(ACTIVITY_MODAL_TYPE);
export const NUMERAL_LOCALES = Object.values(NUMERICAL_LOCALE);
export const NEXT_LOCALES = Object.values(NEXT_LOCALE);
export const REQUEST_METHODS = Object.values(REQUEST_METHOD);
export const HTTP_HEADERS = Object.values(HTTP_HEADER);
export const HTTP_CONTENT_TYPES = Object.values(HTTP_CONTENT_TYPE);
export const HTML_TAG_NAMES = Object.values(HTML_TAG_NAME);
export const KEY_CODES = Object.values(KEY_CODE);
export const REDUCER_PATHS = Object.values(REDUCER_PATH);
export const QUICK_ACTION_MENY_SOURCE_TYPES = Object.values(QUICK_ACTION_MENU_SOURCE_TYPE);
export const SCALE_ROLES = Object.values(SCALE_ROLE);
export const UNLEASH_FLAGS = Object.values(UNLEASH_FLAG);
export const BUCKET_SIZES = Object.values(BUCKET_SIZE);
export const ACTIVITY_STATUSES = Object.values(ACTIVITY_STATUS);
export const DEVIATION_SEVERITIES = Object.values(DEVIATION_SEVERITY);
export const REALTIME_CUSTOM_FILTER_TYPES = Object.values(REALTIME_CUSTOM_FILTER_TYPE);
export const SITE_AVERAGE_TYPES = Object.values(SITE_AVERAGE_TYPE);
export const CREATION_MODAL_TYPES = Object.values(CREATION_MODAL_TYPE);
export const DEVIATION_MODAL_TYPES = Object.values(DEVIATION_MODAL_TYPE);
export const API_RETURN_TYPES = Object.values(API_RETURN_TYPE);
export const THUNK_ACTION_RESULT_TYPES = Object.values(THUNK_ACTION_RESULT_TYPE);
export const ERROR_TYPES = Object.values(ERROR_TYPE);
